export const MODULE_NAME = 'menuSearch';

export const DEBOUNCE_SEARCH_MILLISECONDS = 2500;

export const SEARCH_PAGE_SIZE = 50;

export const GROCERIES_FILTER_CATEGORIES_MIN_CHARS = 3;

export const GROCERIES_FILTER_CATEGORIES_DEBOUNCE = 1000;

export const LIMIT_SUGGESTIONS_SEARCH = 20;
